import { render, staticRenderFns } from "./BaseTopMenu.vue?vue&type=template&id=54a41fb4&"
import script from "./BaseTopMenu.vue?vue&type=script&lang=js&"
export * from "./BaseTopMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports